import React, { useState } from 'react'
import { FormikValues } from 'formik/dist/types'
import { FormikState } from 'formik'
import {
    ContentForm,
    SectionTitle,
    TypographySection,
    Spacing,
    Button,
    ContentBottom,
    CVData,
} from './styles'
import { useFormik } from 'formik'
import { workWith, loadResume } from 'src/api/authOtp'
import { validationSchema } from './validation'
import { FiltForm } from 'src/components/common/Form'
import { useTranslations } from 'src/provider/LocaleProvider'

export const SectionFormContent = () => {
    const [resume, setResume] = useState<any>({})
    const t = useTranslations()
    const formik = useFormik({
        initialValues: {
            first_name: '',
            phone: '',
            email: '',
            linkedin: '',
            last_name: '',
            curriculum_name: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) =>
            handleSubmitForm(values, resetForm),
    })
    const handleSubmitForm = async (
        values: FormikValues,
        resetForm: (
            nextState?:
                | Partial<
                      FormikState<{
                          curriculum_name: ''
                          first_name: string
                          phone: string
                          email: string
                          linkedin: string
                          last_name: string
                      }>
                  >
                | undefined
        ) => void
    ) => {
        try {
            let urlPresided
            if (resume.name && values.curriculum_name) {
                urlPresided = await loadResume(resume)
            }
            values.url_curriculum = urlPresided?.data.path
            const resp = await workWith(values)
            if (resp.status === 201) {
                resetForm()
            }
        } catch (e) {
            console.error(e)
        }
    }
    const handleLoadResume = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { files } = e.target
        if (files && files[0]) {
            setResume(files[0])
            formik.setFieldValue('curriculum_name', files[0].name)
        }
    }
    return (
        <SectionTitle>
            <TypographySection
                variant={'h1'}
                fontSize={['xxxmedium', 'xxxmedium', 'large', 'xxmedium']}
                fontWeight={600}
            >
                {t('worldWile.vacant.complete')}
            </TypographySection>
            <ContentForm onSubmit={formik.handleSubmit}>
                <Spacing marginBottom={'xxmedium'}>
                    <FiltForm
                        id={'first_name'}
                        name={'first_name'}
                        type={'first_name'}
                        errors={formik.errors.first_name}
                        touched={formik.touched.first_name}
                        value={formik.values.first_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        title={t('fields.firstName.label')}
                    />
                </Spacing>
                <Spacing marginBottom={'xxmedium'}>
                    <FiltForm
                        id={'last_name'}
                        name={'last_name'}
                        type={'last_name'}
                        errors={formik.errors.last_name}
                        touched={formik.touched.last_name}
                        value={formik.values.last_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        title={t('fields.lastName.label')}
                    />
                </Spacing>
                <Spacing marginBottom={'xxmedium'}>
                    <FiltForm
                        id={'phone'}
                        name={'phone'}
                        type={'phone'}
                        errors={formik.errors.phone}
                        touched={formik.touched.phone}
                        value={formik.values.phone}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        title={t('fields.phone.label')}
                    />
                </Spacing>
                <Spacing marginBottom={'xxmedium'}>
                    <FiltForm
                        id={'email'}
                        name={'email'}
                        type={'email'}
                        errors={formik.errors.email}
                        touched={formik.touched.email}
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        title={t('fields.email.label')}
                    />
                </Spacing>
                <Spacing marginBottom={'medium'}>
                    <FiltForm
                        id={'linkedin'}
                        name={'linkedin'}
                        type={'linkedin'}
                        errors={formik.errors.linkedin}
                        touched={formik.touched.linkedin}
                        value={formik.values.linkedin}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        title={'Linkedin'}
                    />
                </Spacing>
                <Spacing marginBottom={'xxmedium'}>
                    <CVData
                        variant={'h1'}
                        fontSize={['xxsmall', 'xxsmall', 'xxsmall', 'xxsmall']}
                        fontWeight={600}
                    >
                        {t('fields.choose.label')}
                    </CVData>
                    <input
                        name="curriculum_name"
                        type="file"
                        accept="application/pdf"
                        onChange={handleLoadResume}
                        onBlur={formik.handleBlur}
                        id="contained-button-file"
                    />
                </Spacing>
                <Spacing marginBottom={'xxmedium'}>
                    <ContentBottom>
                        <Button
                            enable={Object.keys(formik.errors).length !== 0}
                            type="submit"
                        >
                            {t('cta.sendMessage')}
                        </Button>
                    </ContentBottom>
                </Spacing>
            </ContentForm>
        </SectionTitle>
    )
}
